module.exports = __webpack_public_path__ + "media/images/img_recommend_03-1617aca539d51331b58ec4fa8b268689.png";